import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "notificationForm",
        onSubmit: _ctx.addNotification,
        "validation-schema": _ctx.notificationSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Abonné "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                (_ctx.estReclamation)
                  ? (_openBlock(), _createBlock(_component_Field, {
                      key: 0,
                      modelValue: _ctx.abonneId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.abonneId) = $event)),
                      name: "abonne"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.abonnesOptions,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner un abonné" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_component_Field, {
                      key: 1,
                      name: "abonne"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          placeholder: "Rechercher un abonne",
                          "filter-results": false,
                          "min-chars": 3,
                          "resolve-on-load": false,
                          delay: 0,
                          searchable: true,
                          "options-limit": 300,
                          options: async (query) => {
                   return await _ctx.fetchAbonnes(query)
                  },
                          noResultText: "Aucun enregistrement trouvé",
                          noOptionsText: "Tapez au moins trois caractères"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 1
                    })),
                _createVNode(_component_ErrorMessage, {
                  name: "abonne",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Message "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "message",
                  cols: "30",
                  modelValue: _ctx.message,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event)),
                  rows: "12",
                  as: "textarea",
                  placeholder: "Ecrire le message",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field}) => [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      class: "form-control shadow-none rounded-0 text-black"
                    }, null, 8, _hoisted_8), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_Field, {
                  name: "demandeId",
                  type: "hidden",
                  modelValue: _ctx.demandeId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.demandeId) = $event)),
                  class: "form-control shadow-none rounded-0 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Field, {
                  name: "estReclamation",
                  type: "hidden",
                  modelValue: _ctx.estReclamation,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.estReclamation) = $event)),
                  class: "form-control shadow-none rounded-0 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "message",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[7] || (_cache[7] = _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit"
                }, " Envoyer une notification ", -1)),
                _createVNode(_component_router_link, {
                  to: "/liste-notifications",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}